var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFilledCheckmark = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 468.02 468.02",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234,0C104.77,0,0,104.77,0,234S104.77,468,234,468,468,363.25,468,234,363.25,0,234,0ZM365.55,185.71,209.71,341.55a13.55,13.55,0,0,1-19.16,0l-88.1-88.1a13.56,13.56,0,0,1,0-19.17l19.17-19.13a13.53,13.53,0,0,1,19.13,0l0,0,59.35,59.34L327.25,147.38a13.55,13.55,0,0,1,19.16,0l19.14,19.17A13.55,13.55,0,0,1,365.55,185.71Z"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilledCheckmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filled-checkmark.c4d248cd.svg";
export { ForwardRef as ReactComponent };